import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=391b8df1&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
import style0 from "@/assets/coupon/style.css?vue&type=style&index=0&id=391b8df1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b8df1",
  null
  
)

export default component.exports